import { Component, OnInit } from '@angular/core';
import { LanguageService } from 'src/app/data-repositories/language.service';

@Component({
  standalone: false,
  selector: 'app-terms-and-conditions',
  templateUrl: './terms-and-conditions.component.html',
  styleUrls: ['./terms-and-conditions.component.scss']
})
export class TermsAndConditionsComponent implements OnInit {

  terms: string;

  constructor(private langService: LanguageService) { }

  ngOnInit() {
    this.langService.getTerms((langInfo) => {
      this.terms = langInfo.termsAndConditions;
    });
  }

}
